document.addEventListener('DOMContentLoaded', async function() {

    /**
     * Formats a date object into a string in the format YYYY-MM-DD.
     * @param {Date} date - The date object to format.
     * @returns {string} The formatted date string.
     */
    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    /**
     * Fetches instances from the Django API.
     */
    async function fetchInstancePages(info, successCallback, failureCallback) {
        let _params = {
            fields: '_,id,start_datetime,end_datetime,calendar_html',
            start_date: formatDate(info.start),
            end_date: formatDate(info.end),
        }

        const currentUrlParams = new URLSearchParams(window.location.search);
        const filterKeys = ['search', 'event_type', 'genre', 'season', 'series', 'venue', 'access_type'];
        filterKeys.forEach(key => {
            if (currentUrlParams.has(key)) {
                _params[key === 'search' ? 'event_title' : key] = currentUrlParams.get(key);
            }
        });

        const baseUrl = '/api/attendable/v1/instances/';
        const params = new URLSearchParams(_params);

        try {
            const response = await fetch(`${baseUrl}?${params.toString()}`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Could not fetch instances.');
            }

            const data = await response.json();
            const instances = data.items.map(instance => ({
                id: instance.id,
                start: instance.start_datetime,
                end: instance.end_datetime,
                extendedProps: {
                    html: instance.calendar_html,
                },
            }));
            console.log(instances);

            successCallback(instances);
        } catch (error) {
            console.error('Error fetching instances:', error);
            failureCallback(error);
        }
    }

    const calendarEl = document.getElementById('calendar');
    if (calendarEl) {
        const calendar = new FullCalendar.Calendar(calendarEl, {
            initialView: 'listWeek',
            firstDay: 1,
            events: fetchInstancePages,
            eventContent: (arg) => ({ html: arg.event.extendedProps.html }),
            initialDate: calendarEl.dataset.initialDate ?? null,
        });
        calendar.render();
    }
});
